import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import React from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import renderToolbar from './Toolbar';

export interface PDFViewerProps {
  url: string;
}

const PDFViewer = ({ url }: PDFViewerProps) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],
    renderToolbar,
  });
  return (
    <Viewer
      plugins={[defaultLayoutPluginInstance]}
      fileUrl={`${url}#view=FitH&toolbar=0&scrollbar=0`}
    />
  );
};

export default PDFViewer;
